/* @flow */

import { useEffect, useContext } from "react";
import { useSendMessage, useData } from "crustate/react";
import { StoreInfoContext } from "entrypoint/shared";
import { CustomerData } from "data";
import { getCustomerData } from "helpers/utils";
import { addMessage } from "state/messages";

const useNotifyMissingAccountDetails = () => {
  const sendMessage = useSendMessage();
  const customer = getCustomerData(useData(CustomerData));
  const {
    content: {
      accountview: content,
    },
  } = useContext(StoreInfoContext);

  useEffect(() => {
    // Always notify if phonenumber missing
    if (content.telephoneNotify !== undefined &&
      content.telephoneNotify !== null &&
      content.telephoneNotify === true &&
      !customer?.addresses[0].telephone) {
      sendMessage(addMessage("NUMBER_NOT_FOUND", "account-details-missing"));
    }

    if (content.showDob !== undefined &&
      content.showDob !== null &&
      content.showDob === true &&
      !customer?.dob) {
      sendMessage(addMessage("DOB_NOT_FOUND", "account-details-missing"));
    }

    if (content.firstnameNotify !== undefined &&
      content.firstnameNotify !== null &&
      content.firstnameNotify === true &&
      !customer?.firstname) {
      sendMessage(addMessage("FIRSTNAME_NOT_FOUND", "account-details-missing"));
    }

    if (content.lastnameNotify !== undefined &&
      content.lastnameNotify !== null &&
      content.lastnameNotify === true &&
      !customer?.lastname) {
      sendMessage(addMessage("LASTNAME_NOT_FOUND", "account-details-missing"));
    }

    if (content.emailNotify !== undefined &&
      content.emailNotify !== null &&
      content.emailNotify === true &&
      !customer?.email) {
      sendMessage(addMessage("EMAIL_NOT_FOUND", "account-details-missing"));
    }

    if (content.showGender !== undefined &&
      content.showGender !== null &&
      content.showGender === true &&
      content.genderNotify !== undefined &&
      content.genderNotify !== null &&
      content.genderNotify === true &&
      !customer?.gender) {
      sendMessage(addMessage("GENDER_NOT_FOUND", "account-details-missing"));
    }

    if (content.orgnrNotify !== undefined &&
      content.orgnrNotify !== null &&
      content.orgnrNotify === true &&
      !customer?.addresses[0].awarditOrgNr) {
      sendMessage(addMessage("ORGNR_NOT_FOUND", "account-details-missing"));
    }
  }, []);
};

export default useNotifyMissingAccountDetails;
